<template>
	<div class="_root-page-name -p-small relative m-c -e0">
		<div class="background absolute inset-0 m-t" />
		<div ref="slotRef" class="-label relative inline-block m-c whitespace-nowrap">
			<span ref="nameRef" class="m-t -p-small">{{ name }}</span>
			<span ref="auxRef" class="aux absolute left-0 top-0 m-t" inert aria-hidden="true">{{
				activeName
			}}</span>
		</div>
	</div>
</template>

<script setup>
import { gsap } from 'gsap'
import { useRoute } from '#app'
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { getActiveContext } from '@/components/core'
import { useEmitter } from '@/composables/core'

function createNameTransition({ slot, name, aux }) {
	gsap.set(aux, { yPercent: 110 })

	function run() {
		return new Promise((resolve) => {
			const width = aux.offsetWidth

			gsap.to(name, { duration: 0.25, ease: 'power2.in', yPercent: -110 })
			gsap.to(slot, { duration: 0.3, delay: 0.2, ease: 'power3.inOut', width })
			gsap.to(aux, { duration: 0.45, ease: 'power3', delay: 0.38, yPercent: 0, onComplete })

			function onComplete() {
				resolve()

				setTimeout(() => {
					gsap.set(slot, { clearProps: 'width' })
					gsap.set(name, { yPercent: 0 })
					gsap.set(aux, { yPercent: 110 })
				}, 0)
			}
		})
	}

	return { run }
}

const props = defineProps({
	animate: { type: Boolean, default: true },
})

const route = useRoute()
const emitter = useEmitter()
const activeName = ref('Büropage')
const name = ref('Büropage')
const transition = ref(null)
const slotRef = ref(null)
const nameRef = ref(null)
const auxRef = ref(null)
let removeGameListener = null

function syncPageName(animate = props.animate) {
	nextTick(() => {
		const page = getActiveContext()

		if (page) {
			Promise.resolve(page.loader?.loaded).then(() => {
				activeName.value = page.name

				if (animate && transition.value) {
					nextTick(() => {
						transition.value.run().then(() => {
							name.value = activeName.value
						})
					})
				} else {
					name.value = page.name
				}
			})
		}
	})
}

watch(
	() => route.name,
	() => {
		syncPageName(props.animate)
	},
)

function game(score) {
	name.value = score
	activeName.value = score
}

onMounted(() => {
	removeGameListener = emitter.on('404-game-score', game)

	nextTick(() => {
		const page = getActiveContext()

		if (page) {
			name.value = page.name
			activeName.value = page.name
		}

		nextTick(() => {
			transition.value = createNameTransition({
				slot: slotRef.value,
				name: nameRef.value,
				aux: auxRef.value,
			})
		})
	})
})

onBeforeUnmount(() => {
	removeGameListener?.()
})
</script>

<style lang="scss" scoped>
@use '../atoms.scss';

._root-page-name {
	color: $white;

	padding: rs(4, 4) rs(10, 10) !important;

	border-radius: rs(12, 12);
	color: $black;

	& > .background {
		background-color: $white;
		border-radius: inherit;
	}

	& > * {
		will-change: width;
	}

	.-label {
		.m-t {
			color: $black;
			@include p-small;
		}
	}
}
</style>
